"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactCollapse = require("react-collapse");
var _Icon = require("b2b-components/theme/components/Icon");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _ = require("./");
require("./Section.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Section = _ref => {
  let {
    children,
    sectionId,
    index,
    onClick,
    title,
    isOpen = false,
    titleSize = _.TITLE_SIZE.default,
    arrowPosition = _.ARROW_POSITION.left,
    className,
    titleClassName,
    contentClassName
  } = _ref;
  const ariaControls = `${_.SECTION_ELEMENT_ID.content}-${sectionId}-${index}`;
  const ariaLabelledBy = `${_.SECTION_ELEMENT_ID.heading}-${sectionId}-${index}`;
  const [isHydrated, setIsHydrated] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setIsHydrated(true);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    suppressHydrationWarning: true,
    className: (0, _classnames.default)('cds-Accordion-Section', {
      'cds-Accordion-Section--Open': isOpen
    }, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    suppressHydrationWarning: true,
    id: ariaLabelledBy,
    "aria-controls": ariaControls,
    "aria-level": 1,
    onClick: () => onClick?.(),
    onKeyPress: () => onClick?.(),
    role: "heading",
    className: (0, _classnames.default)('cds-Accordion-SectionTitle', {
      'cds-Accordion-SectionTitle--Open': isOpen,
      [`cds-Accordion-SectionTitle--${(0, _upperCase.upperCaseFirst)(titleSize)}`]: titleSize !== _.TITLE_SIZE.default
    }, {
      'cds-Accordion-SectionTitle--ArrowRight': arrowPosition === _.ARROW_POSITION.right
    }, titleClassName)
  }, arrowPosition === _.ARROW_POSITION.left && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-Accordion-SectionTitle-ArrowIcon",
    name: _Icon.ICON_NAME.arrowDown,
    size: titleSize === _.TITLE_SIZE.large ? _Icon.ICON_SIZE.small : _Icon.ICON_SIZE.xsmall
  }), /*#__PURE__*/_react.default.createElement("div", null, title), arrowPosition === _.ARROW_POSITION.right && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-Accordion-SectionTitle-ArrowIcon",
    name: _Icon.ICON_NAME.arrowDown,
    size: titleSize === _.TITLE_SIZE.large ? _Icon.ICON_SIZE.small : _Icon.ICON_SIZE.xsmall
  })), isHydrated ? /*#__PURE__*/_react.default.createElement(_reactCollapse.Collapse, {
    isOpened: isOpen
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: ariaControls,
    "aria-labelledby": ariaLabelledBy,
    role: "region",
    className: (0, _classnames.default)('cds-Accordion-SectionContent', contentClassName)
  }, children)) : null);
};
exports.Section = Section;
//# sourceMappingURL=Section.js.map